// extracted by mini-css-extract-plugin
export default {"label":"Details_label__-Tiv3","paragraph":"Details_paragraph__BCE3J"};